// @ts-nocheck
/*
 * Oferta del 18 (14 al 18-sep-2026): una Caja 5 de regalo, del sabor que elija el cliente,
 * con el Pack 40, 60 u 80.
 *
 * Por qué existe: en 2025 el regalo había que agregarlo a mano y a varios clientes no les
 * llegó (8 reseñas en Judge.me). Acá el cliente no hace nada: la caja entra sola al carrito,
 * con el sabor de más stock por defecto (ver ORDEN), y puede cambiarlo desde el mismo carrito.
 *
 * Cómo funciona:
 * - Un pack en el carrito son 2, 3 o 4 Cajas de 20 más un descuento automático. Por eso la
 *   regla es una sola: 2+ Cajas de 20 = 1 regalo.
 * - El regalo es un producto propio a $0 (handle abajo) con una variante por sabor, cada una
 *   con el SKU de su Caja 5. No es un descuento: un "Compra X, llévate Y" le quita el precio
 *   de pack a las Cajas de 20 en este plan de Shopify (probado el 13-sep).
 * - No toca ep-cart-drawer.js: envuelve su render() y su renderItem(). Para sacar la oferta
 *   basta con quitar la línea de este script en layout/theme.liquid.
 * - Se apaga solo en FIN aunque nadie lo saque; después de esa hora retira el regalo de los
 *   carritos que lo tengan.
 * - Antes de ir al checkout revisa el carrito una última vez, para que nadie pague sin regalo.
 */
(function () {
  'use strict';

  var FIN = new Date('2026-09-19T00:00:00-03:00'); // viernes 18 a las 23:59, hora de Chile
  var REGALO_HANDLE = 'regalo-caja-5-oferta-18';
  var CAJAS_20 = ['49195419336997', '49195418812709', '51994453213477', '51994461634853'];
  var COLORES = { 'Maní': '#F2C53D', 'Cacao': '#6B3A2A', 'Chocolate Blanco': '#EDE4D0', 'Caramelo': '#E07820' };
  var CLAVE_SABOR = 'epRegalo18Sabor';
  // Orden del selector y sabor por defecto (el primero): de más a menos stock de Caja 5 en
  // Amplifica al 14-sep (Choc. Blanco 326, Caramelo 257, Maní 174, Cacao 169). Fijo a propósito,
  // no se recalcula (decisión de Tomi).
  var ORDEN = ['Chocolate Blanco', 'Caramelo', 'Maní', 'Cacao'];

  // Textos aprobados por Tomi el 14-sep.
  var TEXTOS = {
    lineaTitulo: '🎁 Caja 5 de regalo',
    lineaSabor: 'Sabor: ',
    lineaElige: 'Elige tu sabor',
    lineaPrecio: 'Gratis',
    avisoConRegalo: '🎁 Por llevar tu pack te regalamos una Caja 5. Elige el sabor abajo',
    avisoFaltaUna: 'Suma otra Caja de 20 y te regalamos una Caja 5 del sabor que quieras 🎁',
  };

  var variantes = null; // [{id, sabor}]
  var sincronizando = false;

  function activa() { return new Date() < FIN; }
  function esRegalo(item) { return item.handle === REGALO_HANDLE; }

  function leerPreferido() { try { return sessionStorage.getItem(CLAVE_SABOR); } catch (e) { return null; } }
  function guardarPreferido(id) { try { sessionStorage.setItem(CLAVE_SABOR, String(id)); } catch (e) {} }

  function contarCajas20(cart) {
    var n = 0;
    for (var i = 0; i < cart.items.length; i++) {
      if (CAJAS_20.indexOf(String(cart.items[i].variant_id)) !== -1) n += cart.items[i].quantity;
    }
    return n;
  }

  function obtenerVariantes() {
    if (variantes) return Promise.resolve(variantes);
    return fetch('/products/' + REGALO_HANDLE + '.js')
      .then(function (r) { if (!r.ok) throw new Error('regalo no disponible'); return r.json(); })
      .then(function (p) {
        variantes = p.variants.map(function (v) { return { id: v.id, sabor: v.option1 }; });
        variantes.sort(function (a, b) {
          var ia = ORDEN.indexOf(a.sabor), ib = ORDEN.indexOf(b.sabor);
          return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
        });
        return variantes;
      });
  }

  function variantePreferida() {
    return obtenerVariantes().then(function (vs) {
      var pref = leerPreferido();
      for (var i = 0; i < vs.length; i++) if (String(vs[i].id) === pref) return vs[i].id;
      return vs[0].id; // el primero de ORDEN: el sabor con más stock
    });
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) { return r.json(); });
  }

  // Deja el carrito con 0 o 1 regalo según corresponda. Devuelve true si cambió algo.
  function ajustar(cart) {
    var quiero = activa() && contarCajas20(cart) >= 2 ? 1 : 0;
    var lineas = cart.items.filter(esRegalo);
    var tengo = lineas.reduce(function (s, it) { return s + it.quantity; }, 0);
    if (tengo === quiero && lineas.length <= 1) return Promise.resolve(false);

    // Si hay más de una línea de regalo (por ejemplo, agregó otro pack con otro sabor desde el
    // selector de la Caja 20), se queda la del sabor elegido por último, no la más antigua.
    var pref = leerPreferido();
    var quedarse = 0;
    lineas.forEach(function (it, i) { if (String(it.variant_id) === pref) quedarse = i; });

    var cadena = Promise.resolve();
    lineas.forEach(function (it, i) {
      var cantidad = (quiero === 1 && i === quedarse) ? 1 : 0;
      if (it.quantity !== cantidad) {
        cadena = cadena.then(function () { return post('/cart/change.js', { id: it.key, quantity: cantidad }); });
      }
    });
    if (quiero === 1 && lineas.length === 0) {
      cadena = cadena.then(variantePreferida).then(function (id) {
        return post('/cart/add.js', { items: [{ id: id, quantity: 1 }] });
      });
    }
    return cadena.then(function () { return true; });
  }

  function leerCarrito() { return fetch('/cart.js').then(function (r) { return r.json(); }); }

  function sincronizar() {
    return leerCarrito().then(function (cart) {
      return ajustar(cart).then(function (cambio) { return cambio ? leerCarrito() : cart; });
    });
  }

  function pintarAviso(cart) {
    var items = document.getElementById('ep-cart-items');
    if (!items) return;
    var aviso = document.getElementById('ep-regalo-18-aviso');
    if (!aviso) {
      aviso = document.createElement('div');
      aviso.id = 'ep-regalo-18-aviso';
      aviso.style.cssText = 'margin:8px 16px 0;padding:10px 12px;border-radius:10px;background:#FFF4E5;'
        + 'color:#7A3E00;font-size:13px;line-height:1.35;font-weight:600;text-align:center;';
      items.parentNode.insertBefore(aviso, items);
    }
    var conRegalo = cart.items.some(esRegalo);
    if (!activa() || cart.item_count === 0) { aviso.hidden = true; return; }
    if (conRegalo) { aviso.textContent = TEXTOS.avisoConRegalo; aviso.hidden = false; }
    else if (contarCajas20(cart) === 1) { aviso.textContent = TEXTOS.avisoFaltaUna; aviso.hidden = false; }
    else { aviso.hidden = true; }
  }

  function renderRegalo(item) {
    var img = item.image ? item.image.replace(/(\.\w+)(\?|$)/, '_100x100$1$2') : '';
    var swatches = (variantes || []).map(function (v) {
      var sel = String(v.id) === String(item.variant_id) ? ' ep-cart-drawer__caja20-swatch--selected' : '';
      return '<button type="button" class="ep-cart-drawer__caja20-swatch' + sel + '" data-regalo-variante="' + v.id
        + '" style="background:' + (COLORES[v.sabor] || '#ccc') + '" aria-label="' + v.sabor + '" title="' + v.sabor + '"></button>';
    }).join('');
    // Sin link, sin botones de cantidad y sin "Eliminar": el regalo no se toca a mano, solo se cambia el sabor.
    return '<div class="ep-cart-item" data-key="' + item.key + '" data-regalo="1">'
      + '  <div class="ep-cart-item__img-wrap">'
      + (img ? '<img src="' + img + '" alt="" class="ep-cart-item__img" loading="lazy">' : '<div class="ep-cart-item__img-ph"></div>')
      + '  </div>'
      + '  <div class="ep-cart-item__info">'
      + '    <span class="ep-cart-item__title">' + TEXTOS.lineaTitulo + '</span>'
      + '    <p class="ep-cart-item__variant">' + TEXTOS.lineaSabor + (item.variant_title || '') + '</p>'
      + (swatches ? '    <p class="ep-cart-drawer__caja20-swatches-label">' + TEXTOS.lineaElige + '</p>'
        + '    <div class="ep-cart-drawer__caja20-swatches">' + swatches + '</div>' : '')
      + '    <div class="ep-cart-item__bottom">'
      + '      <div></div>'
      + '      <div class="ep-cart-item__prices"><span class="ep-cart-item__price">' + TEXTOS.lineaPrecio + '</span></div>'
      + '    </div>'
      + '  </div>'
      + '</div>';
  }

  function instalar() {
    var D = window.EpCartDrawer;
    if (!D || D.__regalo18) return false;
    D.__regalo18 = true;

    var renderOriginal = D.render.bind(D);
    var renderItemOriginal = D.renderItem.bind(D);

    D.renderItem = function (item) {
      return esRegalo(item) ? renderRegalo(item) : renderItemOriginal(item);
    };

    function pintar(cart) { renderOriginal(cart); pintarAviso(cart); }

    D.render = function (cart) {
      pintar(cart);
      if (sincronizando) return;
      sincronizando = true;
      D._busy = true;
      // Las variantes se cargan antes de pintar el selector de sabor.
      obtenerVariantes().catch(function () { return null; })
        .then(function () { return ajustar(cart); })
        .then(function (cambio) { return cambio ? leerCarrito() : (variantes && cart.items.some(esRegalo) ? cart : null); })
        .then(function (nuevo) {
          D._busy = false;
          sincronizando = false;
          if (nuevo) pintar(nuevo);
        })
        .catch(function () { D._busy = false; sincronizando = false; });
    };

    // Cambio de sabor del regalo: se saca la línea actual y se agrega la variante elegida.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-regalo-variante]');
      if (!btn || D._busy) return;
      var itemEl = btn.closest('[data-key]');
      var nuevoId = btn.getAttribute('data-regalo-variante');
      if (!itemEl || btn.classList.contains('ep-cart-drawer__caja20-swatch--selected')) return;
      e.preventDefault();
      D._busy = true;
      sincronizando = true;
      itemEl.classList.add('ep-cart-item--loading');
      guardarPreferido(nuevoId);
      post('/cart/change.js', { id: itemEl.getAttribute('data-key'), quantity: 0 })
        .then(function () { return post('/cart/add.js', { items: [{ id: Number(nuevoId), quantity: 1 }] }); })
        .then(leerCarrito)
        .then(function (cart) { D._busy = false; sincronizando = false; D.render(cart); })
        .catch(function () { D._busy = false; sincronizando = false; D.refresh(); });
    }, true);

    // Red de seguridad al pagar: se revisa el carrito una última vez antes de ir al checkout.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('#ep-cart-checkout-btn');
      if (!btn) return;
      e.preventDefault();
      btn.style.opacity = '0.6';
      sincronizar()
        .catch(function () {})
        .then(function () { window.location.href = btn.getAttribute('href') || '/checkout'; });
    }, true);

    return true;
  }

  document.addEventListener('DOMContentLoaded', function () {
    // ep-cart-drawer.js se inicializa en su propio DOMContentLoaded; se reintenta hasta que exista.
    var intentos = 0;
    (function esperar() {
      if (instalar() || intentos++ > 40) return;
      setTimeout(esperar, 50);
    })();
  });
})();
